// File: cgp-confirmation-dialog.module.ts
// Author: Joseph M Diaz
// Date: 4/28/2017
// Desc: CGP Confirmation Dialog.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { CgpConfirmationDialogService } from './cgp-confirmation-dialog.service';
import { CgpConfirmationDialogComponent } from './cgp-confirmation-dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule
    ],
    exports: [
        CgpConfirmationDialogComponent
    ],
    declarations: [
        CgpConfirmationDialogComponent
    ],
    providers: [
        CgpConfirmationDialogService
    ]
})
export class CgpConfirmationDialogModule { }